import USER_ROLES from 'constants/user-roles.constant';
import { injectAsyncReducer } from 'app/hermes-redux';
import { isManulifeOriginator } from 'globals/manulife';

// Manulife requirement: block access to Home page
const shouldGrantAccess = () => Promise.resolve(!isManulifeOriginator());

const homeModule = {
  home: {
    name: 'home',
    url: '/home',
    resolver: () =>
      Promise.all([
        import(/* webpackChunkName: "homeFeature" */ './home-feature'),
        import(
          /* webpackChunkName: "perks" */ 'pages/perks-home-page/perks-home-page.reducers'
        ),
      ]).then(([component, reducer]) => {
        injectAsyncReducer('perksHomePage', reducer.default);
        return component;
      }),
    shouldGrantAccess,
    data: {
      title: 'components.main_menu.home',
      mainMenu: 'home',
      showSearch: false,
      section: 'home',
      includeInMenu: true,
      authorizedRoles: [USER_ROLES.all],
      shortcutKeyCode: 48,
    },
  },
  homeConnect: {
    name: 'home-connect',
    url: '/home/connect',
    resolver: () =>
      Promise.all([
        import(/* webpackChunkName: "homeFeature" */ './home-feature'),
        import(
          /* webpackChunkName: "perks" */ 'pages/perks-home-page/perks-home-page.reducers'
        ),
      ]).then(([component, reducer]) => {
        injectAsyncReducer('perksHomePage', reducer.default);
        return component;
      }),
    shouldGrantAccess,
    data: {
      title: 'components.main_menu.home',
      mainMenu: 'home',
      showSearch: false,
      section: 'home',
      includeInMenu: false,
      authorizedRoles: [USER_ROLES.all],
      shortcutKeyCode: 48,
    },
  },
  services: {
    name: 'services',
    shouldGrantAccess,
    url: '/home/services',
    resolver: () =>
      Promise.all([
        import(/* webpackChunkName: "services" */ './services/services-page'),
        import(
          /* webpackChunkName: "eap" */ 'pages/employee-assistance/state/reducer'
        ),
      ]).then(([component, reducer]) => {
        injectAsyncReducer(`life`, reducer.employeeAssistanceReducer);
        return component;
      }),
    data: {
      title: 'services.title',
      mainMenu: 'home',
      showSearch: false,
      section: 'home',
      includeInMenu: false,
      authorizedRoles: [USER_ROLES.all],
      shortcutKeyCode: 48,
    },
  },
};

export default homeModule;
